import { updateLocationQuery } from "../../../../router/actions";
import { getCanonicalPath, getLocation } from "../../../../router/selectors";
import {
  clearSelections,
  setNewSearch,
  updateAdditionalQueryParams,
} from "../../store/actionCreators";
import { setNextPriceRangeToCurrent } from "../../priceRange/thunks";
import getQueryIfNewSearch from "../helpers/getQueryIfNewSearch";
import {
  getFilterStorageKey,
  clearFiltersFromSession,
} from "../../../../../../client/filterSessionStorage";
import { isSaveFiltersExperimentEnabled } from "../../../../../../client/experimentSaveFilters";

export default function applyFacets(options = {}) {
  const { keepSelections = false } = options;

  return (dispatch, getState) => {
    const state = getState();
    const { shouldUpdate, next } = getQueryIfNewSearch(state);

    if (shouldUpdate) {
      const {
        query: { cid },
      } = getLocation(state);

      if (!next.query.refine && isSaveFiltersExperimentEnabled()) {
        const key = getFilterStorageKey({ query: { cid } });
        if (key) {
          clearFiltersFromSession(key);
        }
      }

      let pathname;

      if (cid) {
        const stateWithNewQuery = {
          ...state,
          router: {
            locationBeforeTransitions: {
              query: {
                ...next.query,
                cid,
              },
            },
          },
        };
        pathname = getCanonicalPath(stateWithNewQuery);
      }

      dispatch(setNewSearch());

      dispatch(
        updateLocationQuery({
          query: next.query,
          pathname,
        }),
      );

      dispatch(updateAdditionalQueryParams(next.query));
      dispatch(setNextPriceRangeToCurrent(next.priceRange));
    }

    if (!keepSelections) {
      dispatch(clearSelections());
    }
  };
}
